<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="repairRegistrationVo.pkid > 0 ? '编辑' : '新建'"
      class="replacementBill-edit"
      width="1200px"
      top="2vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        :model="repairRegistrationVo"
        :rules="ruleValidate"
        class="form"
        label-width="120px">
      <div class="title">接机信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="系统编号">
            <el-input v-model="repairRegistrationVo.billNo" placeholder="系统自动生成" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="接收日期">
            <el-date-picker
                v-model="repairRegistrationVo.receiveTime"
                style="width: 190px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="维修周期(天)">
            <el-input v-model="repairRegistrationVo.maintenanceCycle"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="条形码">
            <el-input v-model="repairRegistrationVo.barcode" @keyup.enter.native="getDeliveryBillByCode()"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="原发货单号">
            <el-input v-model="repairRegistrationVo.oldDeliveryBillNo"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="售出月数">
            <el-input v-model="repairRegistrationVo.saleMonth"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="物料代码">
            <el-input v-model="repairRegistrationVo.materialNo" placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectRepairMaterial.open()">
                选择
              </el-button>
            </el-input>
            <material-select ref="selectRepairMaterial" @select="selectMaterial"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="物料型号">
            <el-input v-model="repairRegistrationVo.materialName"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="数量">
            <el-input v-model="repairRegistrationVo.quantity" placeholder="请输入"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title">维修信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="硬件版本">
            <el-input v-model="repairRegistrationVo.hardwareVersion" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="软件版本">
            <el-input v-model="repairRegistrationVo.softwareVersion" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="历史报警">
            <el-input v-model="repairRegistrationVo.historicalAlarms" type="textarea"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="报修故障">
            <el-input v-model="repairRegistrationVo.faultReporting" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="实测故障">
            <el-input v-model="repairRegistrationVo.faultActual" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否完成工装测试">
            <el-radio-group v-model="repairRegistrationVo.isWorkpieceTest">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="更换配件">
            <el-input v-model="repairRegistrationVo.replacementParts" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="维修备注">
            <el-input v-model="repairRegistrationVo.note" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="维修人">
            <el-input v-model="repairRegistrationVo.repairName" placeholder="请选择" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.selectRegionalManager.open()"/>
            </el-input>
            <user-select ref="selectRegionalManager" @select="selectRegionalManager"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="维修状态">
            <el-select v-model="repairRegistrationVo.status">
              <el-option label="已接机" :value="-1"/>
              <el-option label="待签收" :value="0"/>
              <el-option label="已签收" :value="1"/>
              <el-option label="已修" :value="2"/>
              <el-option label="技术分析" :value="3"/>
              <el-option label="分析" :value="5"/>
              <el-option label="报废" :value="4"/>
              <el-option label="退货" :value="6"/>
              <el-option label="已寄回" :value="7"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="责任判定">
            <el-cascader
                v-model="repairRegistrationVo.responsibility"
                :options="responsibilitySelect"
                :props="{ checkStrictly: true }"
                clearable/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title">客户信息</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户名称">
            <el-input v-model="repairRegistrationVo.customerName" readonly placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="终端客户">
            <el-input v-model="repairRegistrationVo.terminalCustomerName"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="是否保修">
            <el-radio-group v-model="repairRegistrationVo.isWarranty">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="客户地址">
            <el-input v-model="repairRegistrationVo.customerAddress" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="送修单位">
            <el-input v-model="repairRegistrationVo.fixUnitName" type="textarea"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="结款方式">
            <el-select v-model="repairRegistrationVo.paymentMethod" clearable placeholder="请选择状态">
              <el-option label="款到发货" value="款到发货"/>
              <el-option label="月结" value="月结"/>
              <el-option label="季度结" value="季度结"/>
              <el-option label="年结" value="年结"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="收货人">
            <el-input v-model="repairRegistrationVo.consignee"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收货人电话">
            <el-input v-model="repairRegistrationVo.consigneeContact"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="返厂快递单号">
            <el-input v-model="repairRegistrationVo.returnCourierNO"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="快递单位">
            <el-input v-model="repairRegistrationVo.deliverWay"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发运快递单号">
            <el-input v-model="repairRegistrationVo.deliverCourierNO"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="3个月内维修次数">
            <el-input v-model="repairRegistrationVo.frequency" placeholder="请输入"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="发运时间">
            <el-date-picker
                v-model="repairRegistrationVo.deliverTime"
                style="width: 190px"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收费金额">
            <el-input v-model="repairRegistrationVo.chargedAmount" @change="onChangeAmount"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          明细表
        </div>
        <el-button
            type="primary"
            style="margin-bottom: 10px"
            @click="addDetails">
          添加物料
        </el-button>
        <el-table
            :data="repairRegistrationVo.details"
            border>
          <el-table-column prop="shapeCode" width="160" align="center" label="序列号">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.shapeCode"
                  autosize
                  type="textarea"
                  placeholder="请输入"
                  @keyup.enter.native="getProcess(scope.row)"/>
            </template>
          </el-table-column>
          <el-table-column prop="replaceMaterialNo" width="160" align="center" label="更换物料">
            <template slot-scope="scope">
              <el-input v-model="scope.row.replaceMaterialNo" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="faultActual" width="160" align="center" label="实测故障">
            <template slot-scope="scope">
              <el-input v-model="scope.row.faultActual" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="repairResult" width="160" align="center" label="检查结果">
            <template slot-scope="scope">
              <el-input v-model="scope.row.repairResult" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="faultDesc" width="160" align="center" label="故障描述">
            <template slot-scope="scope">
              <el-input v-model="scope.row.faultDesc" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="specifications" width="160" align="center" label="型号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.specifications" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="problemType" width="160" align="center" label="问题分类">
            <template slot-scope="scope">
              <el-cascader
                  v-model="scope.row.problemType"
                  :options="options"
                  :props="{ checkStrictly: true }"
                  clearable/>
            </template>
          </el-table-column>
          <el-table-column prop="note" width="160" align="center" label="备注">
            <template slot-scope="scope">
              <el-input v-model="scope.row.note" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column prop="positionNo" width="160" align="center" label="位号">
            <template slot-scope="scope">
              <el-input v-model="scope.row.positionNo" autosize type="textarea" placeholder="请输入"/>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate"
              width="100px">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDelete(scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          附件
        </div>
        <div
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            v-if="repairRegistrationVo.attachments"
            ref="payData1"
            :data="repairRegistrationVo.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="title">品质检验</div>
      <el-row>
        <el-col :span="8">
          <el-form-item label="是否已质检">
            <el-radio-group v-model="repairRegistrationVo.isInspection">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="质检结果">
            <el-radio-group v-model="repairRegistrationVo.inspectionResult">
              <el-radio :label="true">ok</el-radio>
              <el-radio :label="false">ng</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import UploadFile from "@/components/UploadFile";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect";

  export default {
    name: "RepairRegistrationEdit",
    components: {MaterialSelect, UploadFile, CustomerSelect, UserSelect},
    data() {
      return {
        dialogVisible: false,
        uploadLoading: false,
        contentLoading: false,
        submitLoading: false,
        options: [
          {
            value: "PCBA外协",
            label: "PCBA外协",
            children: [{
                         value: "虚焊",
                         label: "虚焊",
                       },
                       {
                         value: "空焊",
                         label: "空焊",
                       },
                       {
                         value: "少件",
                         label: "少件",
                       },
                       {
                         value: "连焊",
                         label: "连焊",
                       },
                       {
                         value: "撞件",
                         label: "撞件",
                       },
                       {
                         value: "错件",
                         label: "错件",
                       },
                       {
                         value: "异物",
                         label: "异物",
                       },
                       {
                         value: "立件/立碑",
                         label: "立件/立碑",
                       },
                       {
                         value: "偏移",
                         label: "偏移",
                       },{
                         value: "反向",
                         label: "反向",
                       },
                       {
                         value: "铜箔断裂",
                         label: "铜箔断裂",
                       },
                       {
                         value: "坏件",
                         label: "坏件",
                       },
            ],
          },
          {
            value: "材料不良",
            label: "材料不良",
          },
          {
            value: "测试正常",
            label: "测试正常",
          },
          {
            value: "生产作业不良",
            label: "生产作业不良",
            children: [{
                         value: "组装不良",
                         label: "组装不良",
                       },
                       {
                         value: "焊接不良",
                         label: "焊接不良",
                       },
                       {
                         value: "漏写程序",
                         label: "漏写程序",
                       },
            ],
          },
          {
            value: "待分析",
            label: "待分析",
          },
          {
            value: "程序BUG",
            label: "程序BUG",
          },
        ],
        responsibilitySelect: [
          {
            value: "原材料",
            label: "原材料",
            children: [{
                         value: "电子料不良",
                         label: "电子料不良",
                       },
                       {
                         value: "其他料不良",
                         label: "其他料不良",
                       },
                       {
                         value: "PCBA外协",
                         label: "PCBA外协",
                       },
            ],
          },
          {
            value: "客户端",
            label: "客户端",
            children: [{
                         value: "客供料",
                         label: "客供料",
                       },
                       {
                         value: "使用不当",
                         label: "使用不当",
                       },
                       {
                         value: "应用环境(水、油、异物、腐蚀等)",
                         label: "应用环境(水、油、异物、腐蚀等)",
                       },
                       {
                         value: "固件异常",
                         label: "固件异常",
                       },
                       {
                         value: "应用问题(过载、过压、堵转等)",
                         label: "应用问题(过载、过压、堵转等)",
                       },
                
            ],
          },
          {
            value: "研发设计",
            label: "研发设计",
            children: [{
                         value: "设计缺陷",
                         label: "电子料不良",
                       },
                       {
                         value: "器件选型",
                         label: "器件选型",
                       },
            ],
          },
          {
            value: "生产作用",
            label: "生产作用",
            children: [{
                         value: "焊接问题",
                         label: "焊接问题",
                       },
                       {
                         value: "装配问题",
                         label: "装配问题",
                       },
                       {
                         value: "工装测试",
                         label: "工装测试",
                       },
            ],
          },
          {
            value: "检查正常",
            label: "检查正常",
            children: [{
              value: "检查正常",
              label: "检查正常",
            },
            ],
          },
          {
            value: "原因不明",
            label: "原因不明",
            children: [{
              value: "疑难杂症",
              label: "疑难杂症",
            },
            ],
          },


        ],
        authIndex: 631,
        imgUrls: [],
        files: [],
        fileList: [],
        repairRegistrationVo: {
          pkid: "",
          billNo: "",
          type: 10,
          receiveTime: "",
          creatTime: "",
          receiveName: "",
          barcode: "",
          materialId: "",
          materialNo: "",
          materialName: "",
          customerName: "",
          attachments: [],
          isWarranty: true,
          isCharge: true,
          hardwareVersion: "",
          softwareVersion: "",
          historicalAlarms: "",
          faultReporting: "",
          faultActual: "",
          maintenanceRecord: "",
          repairId: "",
          repairName: "",
          replacementParts: "",
          note: "",
          status: "",
          repairTime: "",
          saleMonth: "",
          isWorkpieceTest: "",
          oldDeliveryBillNo: "",
          chargedAmount: "",
          maintenanceCycle: "",
          deliverTime: "",
          deliverPeople: "",
          deliverWay: "",
          consigneeContact: "",
          isInspection: "",
          inspectionResult: "",
          details: [],
        },
        ruleValidate: {
          customerName: {required: true, message: "客户名称不能为空", trigger: "blur"},
          orderReturnReasonName: {required: true, message: "退货原因不能为空", trigger: "blur"},
          typeName: {required: true, message: "退货类型不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        if (row) {
          this.repairRegistrationVo.pkid = row.pkid;
          if (this.repairRegistrationVo.pkid > 0) {
            this.getData();
          }
        }
      },
      onChangeAmount() {
        if (this.repairRegistrationVo.chargedAmount) {
          this.repairRegistrationVo.isWarranty = false;
          this.repairRegistrationVo.isCharge = false;
        }
      },
      getProcess(row) {
        if (row.shapeCode) {
          let params = {
            sn: row.shapeCode,
          };
          this.$http.get("basic", "snSerialNos/getVoBySn", params).then((res) => {
            row.materialNo = res.data.materialNo;
            row.specifications = res.data.specification;
            row.materialName = res.data.materialDescription;
          }).catch(() => {
            this.$message.error("未查询到条码对应的物料");
          });
        }

      },
      getDeliveryBillByCode() {
        if (this.repairRegistrationVo.barcode) {
          this.$http.get("basic", `deliveryBillDetailSerialNoes/getDeliveryBillByCode/${this.repairRegistrationVo.barcode}`).then((res) => {
            console.log(res.data);
            this.repairRegistrationVo.oldDeliveryBillNo = res.data.deliveryBillNo;
            this.repairRegistrationVo.saleMonth = res.data.saleMonth;
          }).catch(() => {
            this.$message.error("未查询到条码对应的物料");
          });
        }

      },
      getData() {
        this.$http
          .get("basic", `repairRegistrations/${this.repairRegistrationVo.pkid}`)
          .then(resp => {
            this.repairRegistrationVo = resp.data;
            if (this.repairRegistrationVo.responsibility) {
              this.repairRegistrationVo.responsibility = this.repairRegistrationVo.responsibility.split("/");
            }
            if (this.repairRegistrationVo.details.length>0) {
              this.repairRegistrationVo.details.forEach((item) => {
                if (item.problemType) {
                  item.problemType = item.problemType.split("/");
                }
              });
            }
            this.repairRegistrationVo.attachments.forEach(row => {
              this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                if (res.success) {
                  row.imgUrl = res.data;
                  this.imgUrls.push(row.imgUrl);
                }
              });

            });
          });
      },
      getDetails(row, index) {
        console.log(row);
        // this.repairRegistrationVo.details[index].materialId = row.id;
        this.repairRegistrationVo.details[index].productName = row.name;
        this.repairRegistrationVo.details[index].productModel = row.no;
      },
      addDetails() {
        this.repairRegistrationVo.details.push({
          pkid: 0,
          masterId: 0,
          faultActual: "",
          repairResult: "",
          responsibility: "",
          replaceMaterialNo: "",
          faultDesc: "",
          beforeSpecifications: "",
          afterSpecifications: "",
          positionNo: "",
          problemType: "",
        });
      },
      oneDelete(index) {
        this.repairRegistrationVo.details.splice(index, 1);
      },
      fileDelete(index) {
        this.repairRegistrationVo.attachments.splice(index, 1);
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.repairRegistrationVo.attachments.push(params);
        }
      },
      selectCustomer(row) {
        console.log(row);
        this.repairRegistrationVo.customerName = row.customerName;
        this.repairRegistrationVo.customerId = row.customerID;
      },
      selectCustomer2(row) {
        this.repairRegistrationVo.terminalCustomerName = row.customerName;
        this.repairRegistrationVo.terminalCustomerId = row.customerID;
      },
      selectMaterial(row) {
        this.repairRegistrationVo.materialId = row.id;
        this.repairRegistrationVo.materialNo = row.no;
        this.repairRegistrationVo.materialName = row.name;
        console.log(this.repairRegistrationVo);
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.repairRegistrationVo.responsibility) {
              this.repairRegistrationVo.responsibility = this.repairRegistrationVo.responsibility.join("/");
            }
            if (this.repairRegistrationVo.details.length>0) {
              this.repairRegistrationVo.details.forEach((item) => {
                if (item.problemType) {
                  console.log(item.problemType);
                  item.problemType = item.problemType.join("/");
                }
              });
            }
            this.submitLoading = true;
            if (this.repairRegistrationVo.pkid > 0) {
              this.$http
                .put("basic", "repairRegistrations/updateByCS", this.repairRegistrationVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            } else {
              this.$http
                .post("basic", "repairRegistrations", this.repairRegistrationVo)
                .then(() => {
                  this.submitLoading = false;
                  this.dialogVisible = false;
                  this.$emit("save-success");
                  this.$message.success("保存成功");
                })
                .catch(() => {
                  this.submitLoading = false;
                });
            }
          }
        });
      },
      selectRegionalManager(row) {
        this.repairRegistrationVo.repairId = row.systemUserID;
        this.repairRegistrationVo.repairName = row.employeeName;
      },
    },
  };
</script>
<style lang="scss" scoped>
.title {
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  color: #000;
}
::v-deep .el-dialog{
  top: 15% !important;
  left: 0 !important;
}
</style>